(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .controller('CommunicationStatusDetailController', CommunicationStatusDetailController);

    CommunicationStatusDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'entity', 'CommunicationStatus'];

    function CommunicationStatusDetailController($scope, $rootScope, $stateParams, entity, CommunicationStatus) {
        var vm = this;
        vm.communicationStatus = entity;
        
        var unsubscribe = $rootScope.$on('sigmasfApp:communicationStatusUpdate', function(event, result) {
            vm.communicationStatus = result;
        });
        $scope.$on('$destroy', unsubscribe);

    }
})();
